import { combineReducers } from 'redux';
import filtersReducer from './slices/filters';
import rowReducer from './slices/rowhighlight';
import suppliersReducer from './slices/suppliers';
import opportunitiesReducer from './slices/opportunitiesdata';
import dashboardReducer from './slices/dashboard';
import invoiceReducer from './slices/invoice';
import raiseInvoiceReducer from './slices/raiseInvoice';
import clientReducer from './slices/client';
import projectReducer from './slices/project';
import settingsReducer from './slices/settings';
import discrepancyLogReducer from './slices/discrepancyLog';
import resourcingReducer from './slices/resourcing';
import holidayReducer from './slices/holiday';
import bookingsReducer from './slices/bookings';
import itTicketsReducer from './slices/itTickets';
import townhallReducer from './slices/townhall';
import tdgReducer from './slices/tdg';
import personalLinksReducer from './slices/personalLinks';
import rooReducer from './slices/roo';
import standardsAndTemplatesReducer from './slices/standardsAndTemplates';
import structuralSpecificationReducer from './slices/structuralSpecification';
import kfInvoiceExportReducer from './slices/kfInvoiceExport';
import optionsReducer from './slices/options';
import adminUsersReducer from './slices/adminUsers';
import dashboardPersonalReducer from './slices/dashboardPersonal';
import projectProfileReducer from './slices/projectProfile';
import invoicingDashboardReducer from './slices/invoicingDashboard';
import timesheetsDashboardReducer from './slices/timesheetsDashboard';
import suppliersDashboardReducer from './slices/suppliersDashboard';
import profileTrainingReducer from './slices/profileTraining';
import profileHolidayReducer from './slices/profileHoliday';
import profileSicknessReducer from './slices/profileSickness';
import profileUsersReducer from './slices/profileUsers';
import adminHrReducer from './slices/adminHr';
import manageMomentUserReducer from './slices/manageMomentUser';
import sidebarReducer from './slices/sidebar';
import exportsReducer from './slices/exports';
import publicHolidaysReducer from './slices/publicHolidays';
import projectListOptionsReducer from './slices/projectListOptions';
import projectBillingReducer from './slices/projectBilling';
import plannerTasksReducer from './slices/plannerTasks';

const rootReducer = combineReducers({
  filters: filtersReducer,
  project: projectReducer,
  rowhighlight: rowReducer,
  suppliers: suppliersReducer,
  opportunities: opportunitiesReducer,
  dashboard: dashboardReducer,
  invoice: invoiceReducer,
  raiseInvoice: raiseInvoiceReducer,
  client: clientReducer,
  settings: settingsReducer,
  discrepancyLog: discrepancyLogReducer,
  resourcing: resourcingReducer,
  holiday: holidayReducer,
  bookings: bookingsReducer,
  itTickets: itTicketsReducer,
  townhall: townhallReducer,
  tdg: tdgReducer,
  personalLinks: personalLinksReducer,
  roo: rooReducer,
  standardsAndTemplates: standardsAndTemplatesReducer,
  structuralSpecification: structuralSpecificationReducer,
  kfInvoiceExport: kfInvoiceExportReducer,
  options: optionsReducer,
  adminUsers: adminUsersReducer,
  dashboardPersonal: dashboardPersonalReducer,
  projectProfile: projectProfileReducer,
  invoicingDashboard: invoicingDashboardReducer,
  timesheetsDashboard: timesheetsDashboardReducer,
  suppliersDashboard: suppliersDashboardReducer,
  profileTraining: profileTrainingReducer,
  profileHoliday: profileHolidayReducer,
  profileSickness: profileSicknessReducer,
  profileUsers: profileUsersReducer,
  adminHr: adminHrReducer,
  manageMomentUser: manageMomentUserReducer,
  sidebar: sidebarReducer,
  exports: exportsReducer,
  publicHolidays: publicHolidaysReducer,
  projectListOptions: projectListOptionsReducer,
  projectBilling: projectBillingReducer,
  plannerTasks: plannerTasksReducer,
});

export { rootReducer };